import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import "./NonRKPayStickyToolbar.scss";
import Tooltip from "../../../../../../../../js/components/common/Tooltip";

const NonRKPayStickyToolbar = ({
	total,
	// eslint-disable-next-line react/prop-types
	children,
	onGoBack,
	nonRKPayInvoiceDetailHook,
}) => {
	const { lang } = global;
	const navbarRef = useRef(null);
	const {
		isInvoicingV3,
		togglePrePay,
		selectedClient,
		invoiceState: {
			isEstimate,
			invoiceVersion,
			prePay,
			archived,
			voided,
			estimateFinalized,
			invoiceId
		},
	} = nonRKPayInvoiceDetailHook;

	const onScroll = () => {
		const sticky = 40;

		if (window.scrollY >= sticky) {
			navbarRef.current.classList.add("sticky");
		} else {
			navbarRef.current.classList.remove("sticky");
		}
	};

	const toggleNavCollapse = () => {
		const links = document.getElementById("bs-invoice-navbar-collapse");
		if (links.classList.contains("in")) links.classList.remove("in");
		else links.classList.add("in");
	};

	const isPrepayDisabled = (
		(isEstimate && (estimateFinalized || archived || voided)) ||
		((!invoiceId || invoiceId === "") && !!selectedClient?.EnforceV2NonRKPayInvoicing)
	);

	useEffect(() => {
		onScroll();

		document.addEventListener("scroll", onScroll);

		return () => {
			document.removeEventListener("scroll", onScroll);
		};
	}, []);

	return (
		<div
			ref={navbarRef}
			className="nonrkpay-invoice-subnav hidden-print"
		>
			<nav className="navbar navbar-default width-all">
				<div className="container invoice-container">
					<div className="navbar-header">
						<button
							type="button"
							className="navbar-toggle collapsed"
							data-toggle="collapse"
							data-target="#bs-invoice-navbar-collapse"
							aria-expanded="false"
							onClick={toggleNavCollapse}
						>
							<span className="sr-only">Toggle navigation</span>
							<span className="icon-bar" />
							<span className="icon-bar" />
							<span className="icon-bar" />
						</button>

						<button
							type="button"
							className="btn btn-link navbar-btn back-button"
							onClick={onGoBack}
						>
							<i className="rkf rkf-chevron-left" />
							{` ${lang.t("Go Back")}`}
						</button>

						<div className="sticky-left-content">
							<span>
								<strong>
									{lang.t("Total")}: {total}
								</strong>
							</span>
							<span>
								<If
									condition={
										isInvoicingV3 && isEstimate && (invoiceVersion === 3 || !invoiceVersion)
									}
								>
									<label
										htmlFor="prePay"
									>
										<input
											type="checkbox"
											id="prePay"
											name="prePay"
											checked={prePay}
											disabled={isPrepayDisabled}
											onChange={() => togglePrePay()}
										/>
										{lang.t("Request Prepay")}
										<Tooltip
											content={lang.t("Request Prepay Tooltip_")}
											placement="right"
										>
											<i className="rkf rkf-question-solid tooltip-icon" />
										</Tooltip>
									</label>
								</If>
							</span>
						</div>
					</div>
					<div
						className="collapse navbar-collapse flex-1"
						id="bs-invoice-navbar-collapse"
					>
						<ul className="nav navbar-nav">{children}</ul>
					</div>
				</div>
			</nav>
		</div>
	);
};

NonRKPayStickyToolbar.propTypes = {
	total: PropTypes.string.isRequired,
	onGoBack: PropTypes.func.isRequired,
	nonRKPayInvoiceDetailHook: PropTypes.object.isRequired,
};

export default NonRKPayStickyToolbar;
